module.exports = __webpack_public_path__ + "img/multiplier_free_6.435dce4f.png";